/**
 * Search Console's page floor, shared by the server's primary-query pick (`gsc-primary-query.ts`,
 * which re-exports it) and the review rules that ask whether a page is seen in search
 * (`page-traffic-evidence.ts`). One constant, so the page the product compares on its own Search
 * Console search is never the page the review surface calls unseen.
 */

/**
 * Q2's impressions floor, on the page total over the window. Set by the owner on 2026-10-07 from
 * stage 0's report (docs/release-and-testing/gsc-stage0-manyrequests.com-2026-10-07.md §12):
 * below it the chosen query rests on a median of 19 sightings and no clicks.
 */
export const GSC_PRIMARY_QUERY_MIN_IMPRESSIONS = 250;
